import _ from "underscore";

var LexileGradeLevelLookup = require("lexile-grade-level-lookup.json")

var WidgetItem = require('components/data/widgets/helpers/WidgetItem')
var WidgetTitle = require("components/data/widgets/helpers/WidgetTitle");
var WidgetItemsConfig = require('./WidgetItemsConfig')

//////////// CONSTANTS ////////////
export var QUIZ_WIDGET = "quiz_widget"
export var GOALS_WIDGET = "goals_widget"
export var BOOK_WIDGET = "book_widget"
export var WRITING_WIDGET = "writing_widget"

export var STUDENT_ROLE = 'studentRole'
export var TEACHER_ROLE = 'teacherRole'
export var SCHOOL_ADMIN_ROLE = 'adminRole'
export var DISTRICT_ADMIN_ROLE = 'districtAdminRole'

export var CURRENT = 'current'
export var PERIOD = 'period'
export var YEARLY = 'yearly'
export var GRAPH = 'graph'

export var STUDENT_ENTITY_TYPE = 'student'
export var STUDENT_LIST_ENTITY_TYPE = 'student_list'
export var TEACHER_ENTITY_TYPE = 'teacher'
export var SCHOOL_ORG_ENTITY_TYPE = 'school_org'
export var DISTRICT_ORG_ENTITY_TYPE = 'district_org'

var STUDENT = 'Student'
var ADMIN = 'Admin'
//////////////////////////////////

/////// QUIZ SCORE HELPERS ///////

// determins color of score based on teacher prefs
export function isPassing(evaluation, passingThreshold) {
  var ratio = evaluation.ratio
  var threshold = passingThreshold
  return ratio >= threshold;
}
//////////////////////////////////

////////// DATE HELPERS //////////
function formatDateString(date) {
  var dd = String(date.getDate()).padStart(2, '0');
  var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = date.getFullYear();

  return yyyy + '-' + mm + '-' + dd;
}

function todaysDate() {
  var today = new Date();
  return formatDateString(today)
}

function yesterdaysDate() {
  var yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  return formatDateString(yesterday)
}
//////////////////////////////////

////////// GOALS HELPERS /////////

// returns list of widget lookup and digest keys
// based on what's in the user's digest
function getGoalsFromUserDigest(userDigest) {
  return _.first(_.compact(_.map(_.keys(userDigest), digest_key => {
    var widget_key = WidgetItemsConfig.GOAL_TO_WIDGET_KEY[digest_key]
    return widget_key ? { digest_key, widget_key } : null
  })), 4)
}

// outputs font color for a single student goal based on 
// progress and today's date relative to goal start and end dates
function goalProgressColor(startDate, endDate, progress) {
  var start = new Date(startDate)
  var end = new Date(endDate)
  var today = new Date();

  var pct = (Math.abs(today - start) / Math.abs(end - start))

  if (progress >= 1) {
    var color = 'green'  // student has completed goal
  } else if (progress >= pct) {
    var color = 'yellow'
  } else {
    var color = 'red'
  }

  return color
}

// dynamically change width of goal widget items
// based on number of goals
function getGoalsWidth(numGoals) {
  if (numGoals == 4) { return 25 }
  if (numGoals == 3) { return 33 }
  if (numGoals <= 2) { return 50 }
}

// returns progress overview for teachers
function getStudentGoalProgress(userDigests) {
  var totalProgress = {
    [WidgetItemsConfig.GOALS_COMPLETE]: { count: 0, userIDs: [] },
    [WidgetItemsConfig.GOALS_ON_PACE]: { count: 0, userIDs: [] },
    [WidgetItemsConfig.GOALS_BEHIND]: { count: 0, userIDs: [] }
  }
  
  var idx = 0
  _.each(userDigests, digest => {    
    // for each goals, calculate if the student is on pace, behind, or has completed
    var goalsBehind = 0
    var goalsOnPace = 0
    var goalsCompleted = 0
    
    var goals = getGoalsFromUserDigest(digest)    
    _.each(goals, goal => {
      var expectation = digest[`${goal.digest_key}_expectation`]
      var completed = digest[goal.digest_key]
      var goalBenchmark = getPaceBenchmark(digest.start_date, digest.end_date, expectation)

      if (completed >= expectation) {
        goalsCompleted += 1
      } else if (completed >= goalBenchmark) {
        goalsOnPace += 1
      } else {
        goalsBehind += 1
      }
    })

    // categorize each student will as either complete, on-pace, or behind
    // userIDs will be kept track for linking purposes
    var studentBenchmark = getPaceBenchmark(digest.start_date, digest.end_date, _.size(goals))
    if (goalsCompleted == _.size(goals)) {
      totalProgress[WidgetItemsConfig.GOALS_COMPLETE]['count'] += 1
      totalProgress[WidgetItemsConfig.GOALS_COMPLETE]['userIDs'].push(digest.student_id)
    } else if ((goalsCompleted + goalsOnPace) >= studentBenchmark) {
      totalProgress[WidgetItemsConfig.GOALS_ON_PACE]['count'] += 1
      totalProgress[WidgetItemsConfig.GOALS_ON_PACE]['userIDs'].push(digest.student_id)
    } else {
      totalProgress[WidgetItemsConfig.GOALS_BEHIND]['count'] += 1
      totalProgress[WidgetItemsConfig.GOALS_BEHIND]['userIDs'].push(digest.student_id)
    }

    idx += 1
  })

  if (idx == _.size(userDigests)) {
    return totalProgress
  }
}

// returns the on-pace value of where a goal should be
// if a student was perfectly on pace to finish
function getPaceBenchmark(startDate, endDate, goal) {
  var start = new Date(startDate)
  var end = new Date(endDate)
  var today = new Date();

  var pct = (Math.abs(today - start) / Math.abs(end - start))
  return Math.round(goal * pct)
}

// pluralizes and gives subject for goals title
function buildAdminDashboardGoalsTitle(metric, item) {
  var plural = metric != 1  
  var subject = plural ? 'students' : 'student'

  if (item == WidgetItemsConfig.GOALS_COMPLETE) {
    return `${subject} ${plural ? 'have' : 'has'} completed all goals`
  } else if (item == WidgetItemsConfig.GOALS_ON_PACE) {
    return `${subject} ${plural ? 'are' : 'is'} on pace to complete all goals`
  } else if (item == WidgetItemsConfig.GOALS_BEHIND) {
    return `${subject} ${plural ? 'are' : 'is'} behind pace to complete all goals`
  }
}

// pluralized goals title
function buildDataStudentDigestGoalsTitle(progress, title) {
  return progress == 1 ? title.replace('goals', 'goal') : title
}
//////////////////////////////////

////////// METRICS ///////////////

// adds commas if needed
function formatNumberString(statText) {
  if (statText) {
    return statText.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }
}

// VERY IMPORTANT FUNCTION
// it outputs a hash that contains all information that the FE needs to display primary metric
function calculatePrimaryMetric(digests, metricName, rangeMax, comp) {
  if (_.isEmpty(digests)) { return null }
  // for average metrics, we need to take average of all digest values
  if (_.includes(WidgetItemsConfig.AVERAGE_METRICS, metricName)) {
    var totalMetric = 0
    _.each(digests, digest => {
      totalMetric += digest[metricName]
    })
    var metric = totalMetric / _.size(digests)
  } else {
    // for total metrics, sum up the specific metric from all digets supplied
    var metric = _.pluck(digests, metricName).reduce((partialSum, a) => partialSum + a, 0);
    metric = isNaN(metric) || metric < 0 ? 0 : metric
  }

  return formatPrimaryMetric(metric, rangeMax, comp)
}

// VERY IMPORTANT FUNCTION AGAIN
// this outputs the text of the metric as well as information about it's color and size
function formatPrimaryMetric(metric, rangeMax, comp) {
  var shared = { metric }

  // if we have a comparison, the stat color will be determined by how the current
  // user is doing relative to their comp benchmark
  if (comp) {
    if (comp.success_below_comp) {
      var statColor = Math.round(10*metric)/10 <= Math.round(10*comp.metric)/10 ? 'green' : 'red'
    } else {      
      var statColor = Math.round(10*metric)/10 >= Math.round(10*comp.metric)/10 ? 'green' : 'red'
    }
    metric = Math.round(metric * 10) / 10
    shared = { ...shared, statColor }
  }

  // if the metric is just a word, no further calculation is needed
  if (typeof metric == 'string') {
    return { ...shared, statText: metric, 'statSize': 'medium' }
  }

  // prevent metric texts from getting too long and breaking the styling
  var statText = metric > rangeMax ? `${formatNumberString(String(rangeMax))}+` : formatNumberString(String(metric))

  // statSize is used in CSS to style the text and icons on a widget item
  if (String(metric).length > 6) { return { ...shared, statText, 'statSize': 'x-large' } }
  if (String(metric).length > 3) { return { ...shared, statText, 'statSize': 'large' } }
  if (String(metric).length == 3) { return { ...shared, statText, 'statSize': 'medium' } }
  if (String(metric).length == 2) { return { ...shared, statText, 'statSize': 'small' } }
  if (String(metric).length == 1) { return { ...shared, statText, 'statSize': 'x-small' } }
}

// the secondary metric (including comparisons and time periods)
function formatSecondaryMetric(metricName, digests, user, comp) {
  // if there is a comparison, return the scope and the metric
  if (comp && !isNaN(comp.metric)) { return `${comp.scope} Avg: ${comp.metric}` }

  if (!metricName) { return null }
  
  // handle last active
  if (metricName == 'last_active') { return 'since last visit' }

  // handle determine time period based on expectations
  if (metricName == 'time_period') {
    if (_.first(digests).period == 'yearly') {
      return 'this year'
    } else if (_.first(digests).period == 'current') { 
      return 'past 24 hours'
    } else if (user.prefs && user.prefs.expectations_time_period) {
      return `this ${user.prefs.expectations_time_period}`
    } else {
      return 'this grading period'
    }
  }

  // if (metricName == 'goals_time_period') { return `this ${digests.goals_time_period}` }
}
//////////////////////////////////

//////// COMPARISONS /////////////

// returns hash of comparison metrics
function getComparison(metric, compDigests, compSize, scope) {
  // sum up specific metric in all compDigests
  var compMetric = _.pluck(compDigests, metric).reduce((partialSum, a) => partialSum + a, 0);
  // compSize is the size of all digests if dealing with average metric
  compSize = _.includes(WidgetItemsConfig.AVERAGE_METRICS, metric) ? _.size(compDigests) : compSize
  // average quiz score is handled differently for rounding purposes
  if (metric == 'average_quiz_score') { 
    var avg = Math.round((compMetric / compSize) * 10) / 10
  } else {
    var avg = Math.round(compMetric / compSize)
  }

  return { scope, metric: avg, success_below_comp: _.includes(WidgetItemsConfig.SUCCESS_BELOW_COMP, metric) }
}
//////////////////////////////////

//////// WIDGET ITEM DATA ////////
// gives list of widget items in order
export function getWidgetItemsConfig(userRole) {
  switch (userRole) {
    case DISTRICT_ADMIN_ROLE:
      return WidgetItemsConfig.districtAdminDigestMetrics
    case SCHOOL_ADMIN_ROLE:
      return WidgetItemsConfig.schoolAdminDigestMetrics
    case TEACHER_ROLE:
      return WidgetItemsConfig.teacherDigestMetrics
    default:
      return WidgetItemsConfig.studentDigestMetrics
  }
}
// gives widget item data based on user role
function getWidgetItemData(userRole, widgetType) {
  switch (userRole) {
    case DISTRICT_ADMIN_ROLE:
      return extractWidgetItems(WidgetItemsConfig.districtAdminDigestMetrics, widgetType)
    case SCHOOL_ADMIN_ROLE:
      return extractWidgetItems(WidgetItemsConfig.schoolAdminDigestMetrics, widgetType)
    case TEACHER_ROLE:
      return extractWidgetItems(WidgetItemsConfig.teacherDigestMetrics, widgetType)
    default:
      return extractWidgetItems(WidgetItemsConfig.studentDigestMetrics, widgetType)
  }
}

// logic to extract order of widget items
// also sends information about width of snapshot item
function extractWidgetItems(widgets, widgetName) {
  var items = _.map(widgets, widget => {
    var key = _.first(_.keys(widget))
    if (key == widgetName) {
      return widget[key]
    }
  })

  var items = _.first(_.without(items, undefined))
  var width = Math.round(_.size(items) >= 4 ? 25 : 100 / _.size(items))

  return { items, width }
}
//////////////////////////////////

////////// LEXILE LEVEL //////////
function getAverageLexileLevel(user, digests) {
  // get total lexile of all digests
  var totalLexile = _.pluck(digests, 'average_lexile_level').reduce((partialSum, a) => partialSum + a, 0);
  // average metrics and roud to nearest 50
  var avgLexile = String(Math.round(totalLexile / _.size(digests) / 50) * 50)
  // lookup academic level and change color accordingly
  if (user.prefs && user.prefs.academic_level) {
    var userAcademicLevel = user.prefs.academic_level
    var gradeLevelForLexile = parseInt(LexileGradeLevelLookup[avgLexile])
    var LexileForGradeLevel = getKeyByValue(LexileGradeLevelLookup, String(userAcademicLevel))
    var statColor = gradeLevelForLexile >= userAcademicLevel ? 'green' : 'red'
  } else {
    var statColor = 'black'
  }
  return { LexileForGradeLevel: formatNumberString(LexileForGradeLevel), metric: avgLexile, statColor, statText: formatNumberString(avgLexile), statSize: 'medium' }
}

function getKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value);
}

//////////////////////////////////

////////// USER HELPERS //////////
export function getEntityTypeByUserRole(role) {
  switch (role) {
    case STUDENT_ROLE:
      return STUDENT_ENTITY_TYPE
    case TEACHER_ROLE:
      return TEACHER_ENTITY_TYPE
    case SCHOOL_ADMIN_ROLE:
      return SCHOOL_ORG_ENTITY_TYPE
    case DISTRICT_ADMIN_ROLE:
      return DISTRICT_ORG_ENTITY_TYPE
  }
}
//////////////////////////////////

///////// LINK BUILDERS /////////
export function buildCurrentMetricLink(base) {
  return `${base}&start_date=${yesterdaysDate()}&end_date=${todaysDate()}`
}

export function buildTimePeriodLink(base, digest) {
  var start = formatDateString(new Date(digest.start_date))
  var end = formatDateString(new Date(digest.end_date))

  return `${base}&start_date=${start}&end_date=${end}`
}

export function buildStudentDataLink(userID, filters, subject, digest) {
  var start = formatDateString(new Date(digest.start_date))
  var end = formatDateString(new Date(digest.end_date))
  var filters = !_.isEmpty(filters) ? `${filters.join('&')}&` : ''

  return `/data/${userID}/${subject}?${filters}start_date=${start}&end_date=${end}`
}

export function buildLink(base, digest) {
  var { period } = digest
  if (period == CURRENT) {
    return buildCurrentMetricLink(base)
  } else {
    return buildTimePeriodLink(base, digest)
  }
}
//////////////////////////////////

/////// EMPTY STATE HELPER ///////

// determine if empty state should show
export function showEmptyState(widgetDigests) {
  // create array of data hashes from digests
  var widgetDigestData = _.pluck(widgetDigests, 'data')

  // sums values of all keys that we want to check on the dashboards
  // all must be 0 to show empty state
  var checkValues = _.map(widgetDigestData, (dataHash) => {
    return _.filter(dataHash, (val, key) => {
      return _.includes(WidgetItemsConfig.NON_GOAL_METRICS, key)
    }).reduce((partialSum, a) => partialSum + a, 0)
  })

  if (_.isEmpty(widgetDigestData)) {
    // if widget digests don't exist, show empty state
    return true
  } else if (!_.any(checkValues, metric => { return metric > 0 })) {
    // if all metrics are 0, show empty state
    return true
  } else {
    return false
  }
}
//////////////////////////////////

////// RENDER WIDGET ITEMS //////

// VERY IMPORTANT FUNCTION
// handles most of the rendering of widgets
export function renderWidgetItems(props, widgetSubject, linkBuilder, emptyState) {
  var { user, compSize, compScope, currentWidgetDigests, periodWidgetDigests, compWidgetDigests, yearlyWidgetDigests } = props  
  
  // user default if period digest doesn't exist
  periodWidgetDigests = _.isEmpty(periodWidgetDigests) ? DEFAULT_WIDGET_DIGESTS : periodWidgetDigests

  // get widget items and order
  var config = user.role == STUDENT_ROLE ? WidgetItemsConfig.CONFIG[STUDENT] : WidgetItemsConfig.CONFIG[ADMIN]
  var widgetItemData = getWidgetItemData(user.role, widgetSubject)

  // loop through widget items
  return _.map(widgetItemData.items, (item, index) => {
    // get configuation for specific widget item
    var itemConfig = { ..._.findWhere(config, { lookup_key: item }) }

    if (emptyState) {
      var digests = DEFAULT_WIDGET_DIGESTS
    } else if (itemConfig.current_metric && !_.isEmpty(currentWidgetDigests)) {
      var digests = currentWidgetDigests // use curentWidgetDigests for current metrics
    } else if (itemConfig.yearly_metric && !_.isEmpty(yearlyWidgetDigests)) {
      var digests = yearlyWidgetDigests // use yearlyWidgetDigests for yearly metrics
    } else {
      var digests = periodWidgetDigests // default, and in most cases, user period
    }
    
    // if widget item config requires a comparison, calculate that
    if (itemConfig.show_comparison && !_.isEmpty(compWidgetDigests)) {
      var comp = getComparison(itemConfig.primary_metric, _.pluck(compWidgetDigests, 'data'), compSize, compScope)
    }

    // some widget items need special rendering that wouldn't fit in this function
    // otherwise, use the calculatePrimaryMetric and formatSecondaryMetric functions
    if (_.includes(WidgetItemsConfig.SPECIAL_RENDERING, item)) {
      itemConfig = handleSpecialRendering(itemConfig, digests, user, comp, compSize)
    } else {
      itemConfig.primaryMetric = calculatePrimaryMetric(_.pluck(digests, 'data'), itemConfig.primary_metric, DEFAULT_MAX_STAT_RANGE, comp)
      itemConfig.secondaryMetric = formatSecondaryMetric(itemConfig.secondary_metric, digests, user, comp)
    }

    // pluralize title
    itemConfig.title = itemConfig.primaryMetric.metric == 1 ? itemConfig.singular_title : itemConfig.title

    // update link based on config properties
    itemConfig.link = linkBuilder(digests[0], itemConfig, itemConfig.primary_metric)

    // annoying little line to add the divider wall between widget items
    var showDividerColumn = index != 4 && _.size(widgetItemData.items) > index + 1

    return (
      <WidgetItem
        {...itemConfig}
        key={itemConfig.title}
        width={widgetItemData.width}
        dividerColumn={showDividerColumn}
        sideScroll={false} // used if we have more than 4 items in a row
      />
    )
  })
}

function handleSpecialRendering(itemConfig, digests, user, comp) {
  var newItemConfig = { ...itemConfig }

  switch (newItemConfig.primary_metric) {
    // average quiz score needs the score to be converted before displaing
    case WidgetItemsConfig.AVERAGE_QUIZ_SCORE:
      var primaryMetric = calculatePrimaryMetric(_.pluck(digests, 'data'), newItemConfig.primary_metric, DEFAULT_MAX_STAT_RANGE, comp)
      var studentConvertedScore = $wr.convertedScore(primaryMetric.metric, user.prefs.displayScoreCap || 4)

      newItemConfig.primaryMetric = {
        ..._.omit(primaryMetric, ['statText', 'metric', 'statSize']),
        statText: studentConvertedScore,
        metric: studentConvertedScore,
        statSize: 'medium'
      }

      if (comp) {
        comp.metric = $wr.convertedScore(comp.metric, user.prefs.displayScoreCap || 4)
        newItemConfig.secondaryMetric = formatSecondaryMetric(newItemConfig.secondary_metric, digests, user, comp)
      }

      return newItemConfig
    
    // minutes logged are going to need a larger maxRange value
    case WidgetItemsConfig.MINUTES_LOGGED:
      newItemConfig.primaryMetric = calculatePrimaryMetric(_.pluck(digests, 'data'), newItemConfig.primary_metric, DEFAULT_MAX_STAT_RANGE, comp)
      newItemConfig.secondaryMetric = formatSecondaryMetric(newItemConfig.secondary_metric, digests, user, comp)
      return newItemConfig
    
    // average lexile level needs to be calculated separately
    case WidgetItemsConfig.AVERAGE_LEXILE_LEVEL:
      var avgLexile = getAverageLexileLevel(user, _.pluck(digests, 'data'))
      newItemConfig.primaryMetric = avgLexile
      
      if (user.role == STUDENT_ROLE) {
        newItemConfig.secondaryMetric = `Grade Avg: ${avgLexile.LexileForGradeLevel}`
      }

      return newItemConfig
  }
}

export function renderStudentGoalWidgetItems(user, userDigest, showEmptyState) {
  if (_.isEmpty(userDigest)) { return null }

  userDigest = showEmptyState ? DEFAUL_USER_DIGEST : userDigest

  if (userDigest) {
    var goalKeys = getGoalsFromUserDigest(userDigest)
    var width = getGoalsWidth(_.size(goalKeys))
    // loop through goal keys
    return _.map(goalKeys, (gKey, index) => {
      // find widget item config for goal
      var itemConfig = { ..._.findWhere(WidgetItemsConfig.CONFIG[STUDENT], { lookup_key: gKey.widget_key }) }
      itemConfig.primaryMetric = formatPrimaryMetric(userDigest[gKey.digest_key], 100)
      // get goal progress from userDigest
      var goalProgress = userDigest[gKey.digest_key] / userDigest[`${gKey.digest_key}_expectation`]
      itemConfig.primaryMetric.statColor = goalProgressColor(userDigest['start_date'], userDigest['end_date'], goalProgress)
      itemConfig.title = buildDataStudentDigestGoalsTitle(userDigest[gKey.digest_key], itemConfig.title)
      
      // build link based on widget item config
      var { text, filters, subject } = itemConfig.link
      itemConfig.link = {
        text,
        location: buildStudentDataLink(user.id, filters, subject, userDigest)
      }

      var showDividerColumn = index != 4 && _.size(goalKeys) > index + 1

      return (
        <WidgetItem
          {...itemConfig}
          key={itemConfig.title}
          width={width}
          dividerColumn={showDividerColumn}
          sideScroll={false} // used if we have more than 4 items in a row
        />
      )
    })
  }
}

export function renderTeacherGoalWidgetItems(user, userDigests, showEmptyState) {
  if (_.isEmpty(userDigests) && !showEmptyState) { return null }
  // get widget items and order
  var widgetItemData = getWidgetItemData(user.role, GOALS_WIDGET)

  // gets goal progress
  var progress = showEmptyState ? DEFAULT_TEACHER_GOAL_PROGRESS : getStudentGoalProgress(userDigests)
  return _.map(widgetItemData.items, (item, index) => {    
    // config for specific widget item
    var itemConfig = { ..._.findWhere(WidgetItemsConfig.CONFIG[ADMIN], { lookup_key: item }) }

    itemConfig.primaryMetric = formatPrimaryMetric(progress[item]['count'], DEFAULT_MAX_STAT_RANGE)
    itemConfig.primaryMetric.statColor = itemConfig.font_color
    itemConfig.title = buildAdminDashboardGoalsTitle(itemConfig.primaryMetric.metric, item)
    
    // build link based on widget item and userIDs retruned by getStudentGoalProgress
    if (itemConfig.primaryMetric.metric > 0 && userDigests.length > 0) {
      var startDate = userDigests[0].start_date
      var endDate = userDigests[0].end_date
      itemConfig.link = {     
        text: 'View', location: `/data/${progress[item]['userIDs'].join('-')}/goals?start_date=${startDate}&end_date=${endDate}`
      }
    }

    var showDividerColumn = index != 4 && _.size(widgetItemData.items) > index + 1

    return (
      <WidgetItem
        {...itemConfig}
        key={itemConfig.title}
        width={widgetItemData.width}
        dividerColumn={showDividerColumn}
        sideScroll={false} // used if we have more than 4 items in a row
      />
    )
  })
}

export function renderAdminGoalWidgetItems(user, currentWidgetDigests, showEmptyState) {
  // return null if current widget digest hasn't been created yet
  if (!showEmptyState && _.isEmpty(currentWidgetDigests)) { return null }

  // use empty state if no widget digests exists
  currentWidgetDigests = showEmptyState ? DEFAULT_WIDGET_DIGESTS : currentWidgetDigests

  // get widget item names and order
  var widgetItemData = getWidgetItemData(user.role, GOALS_WIDGET)
  
  return _.map(widgetItemData.items, (item, index) => {
    // get config basedon widget item name
    var itemConfig = { ..._.findWhere(WidgetItemsConfig.CONFIG[ADMIN], { lookup_key: item }) }

    // get primary and secondary metric
    itemConfig.primaryMetric = calculatePrimaryMetric(_.pluck(currentWidgetDigests, 'data'), itemConfig.primary_metric, DEFAULT_MAX_STAT_RANGE)
    itemConfig.title = buildAdminDashboardGoalsTitle(itemConfig.primaryMetric.metric, item)
    itemConfig.primaryMetric.statColor = itemConfig.font_color
    itemConfig.secondaryMetric = itemConfig.secondary_metric ? formatSecondaryMetric(itemConfig.secondary_metric, currentWidgetDigests, user) : ""
      
    // link to gaols page
    if (itemConfig.primaryMetric && itemConfig.primaryMetric.metric > 0) {
      itemConfig.link = {
        text: 'View Goals', location: `/data/goals`
      }
    }

    var showDividerColumn = index != 4 && _.size(widgetItemData.items) > index + 1

    return (
      <WidgetItem
        {...itemConfig}
        key={itemConfig.title}
        width={widgetItemData.width}
        dividerColumn={showDividerColumn}
        sideScroll={false} // used if we have more than 4 items in a row
      />
    )
  })
}

export function renderWidgetTitle(widget) {
  return <WidgetTitle config={WIDGET_TITLE_CONFIG[widget]} />
}
//////////////////////////////////

////// WIDGET TITLE CONFIG //////
export var WIDGET_TITLE_CONFIG = {
  // WIDGET HEADERS
  [QUIZ_WIDGET]: {
    icon: 'settings-gears-white',
    title: 'Quizzes'
  },
  [GOALS_WIDGET]: {
    icon: 'magnifier-white',
    title: 'Goals'
  },
  [BOOK_WIDGET]: {
    icon: 'open-book-white',
    title: 'Books'
  },
  [WRITING_WIDGET]: {
    icon: 'writing-white',
    title: 'Writing'
  }
}

//////////////////////////////////

////// DEFAULT WIDGET DIGEST //////
// used when widget digests 
// haven't been created
export var DEFAULT_WIDGET_DIGESTS = [{
  "start_date": yesterdaysDate(),
  "end_date": todaysDate(),
  "data": {
    "days_active": 30,
    "pages_logged": 500,
    "total_quizzes": 20,
    "total_reviews": 10,
    "failed_quizzes": 5,
    "minutes_logged": 600,
    "flagged_books": 2,
    "uniq_book_count": 15,
    "flagged_quizzes": 2,
    "total_with_lexile": 0,
    "average_quiz_score": .71,
    "average_lexile_level": 1000,
    "excercises_completed": 5,
    "total_question_builders": 3,
    "total_practice_questions": 10,
    "students_complete": 10,
    "students_on_pace": 20,
    "students_behind": 5
  },
  "current_period": false
}]

export var DEFAULT_TEACHER_GOAL_PROGRESS = {
  students_behind: { count: 2, userIDs: [] },
  students_complete: { count: 4, userIDs: [] },
  students_on_pace: { count: 7, userIDs: [] },
}

export var DEFAUL_USER_DIGEST = {
  answers_count: 3,
  answers_count_expectation: 4,
  quiz_passed_count: 1,
  quiz_passed_count_expectation: 1,
  reviews_count: 1,
  reviews_count_expectation: 4,
}

var DEFAULT_MAX_STAT_RANGE = 1000000


// WEBPACK FOOTER //
// ./modules/lib/widgets/WidgetsConfig.js